import React from "react";
import { FaAndroid, FaApple, FaChrome, FaDesktop, FaGlobe } from "react-icons/fa";
import { easyonPlatforms } from "../../data/easyonPageContent";
import { EasyonReveal } from "./EasyonMotion";

const platformIcons = {
    android: FaAndroid,
    ios: FaApple,
    chrome: FaChrome,
    desktop: FaDesktop,
    web: FaGlobe,
};

export const EasyonPlatformsSection = () => (
    <section className="eo-platforms">
        <div className="eo-container">
            <EasyonReveal className="eo-platforms__head">
                <span className="eo-eyebrow">Platform Coverage</span>
                <h2 className="eo-h2">Auto-Sync Across Every Device</h2>
                <p className="eo-lead">
                    EasyOn runs on Android, iOS, Desktop, Web, and Chrome Extension with a unified operations feed.
                </p>
            </EasyonReveal>

            <div className="eo-platform-marquee">
                <div className="eo-platform-marquee__track">
                    {[...easyonPlatforms, ...easyonPlatforms].map((platform, i) => {
                        const Icon = platformIcons[platform.iconKey];
                        return (
                            <div key={`${platform.name}-${i}`} className="eo-platform-marquee__item">
                                <Icon size={18} />
                                <span>{platform.name}</span>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    </section>
);
